// extracted by mini-css-extract-plugin
export const nav = "exhibition-hero-module--nav--1Njd5";
export const navItem = "exhibition-hero-module--navItem--F57Dv";
export const light = "exhibition-hero-module--light--2NhT0";
export const dark = "exhibition-hero-module--dark--1b7ML";
export const icon = "exhibition-hero-module--icon--11E3S";
export const image = "exhibition-hero-module--image--1n8uH";
export const title = "exhibition-hero-module--title--325XI";